export default "__VITE_ASSET__a5c0eb46__"